import styled from "styled-components";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";

export const ContentHeader = styled.h2`
  color: ${props => props.theme.vstui.color.primary.getShade(7)};
  font-weight: 500;
  font-size: 3.8rem;
  padding-bottom: 25px;

  ${styledMedia.medium`
    font-size: 3.2rem;
    padding-bottom: 17px;
  `}

  ${styledMedia.small`
    font-size: 2.2rem;
    padding-bottom: 9px;
  `}
`;
